import { apiCall } from './api';
import { z } from 'zod';

const MyCodeResponseSchema = z.object({ code: z.string() });

const ReferralResponseSchema = z.object({
  id: z.string(),
  referredId: z.string(),
  code: z.string(),
  createdAt: z.string(),
});
export type ReferralResponse = z.infer<typeof ReferralResponseSchema>;

export async function fetchMyReferralCode(accessToken: string): Promise<string> {
  const res = await apiCall<unknown>('/referrals/my-code', { accessToken });
  return MyCodeResponseSchema.parse(res.data).code;
}

export async function applyReferralCode(
  accessToken: string,
  code: string,
): Promise<void> {
  await apiCall<unknown>('/referrals/apply', {
    accessToken,
    method: 'POST',
    body: { code },
  });
}

export async function fetchMyReferrals(
  accessToken: string,
): Promise<ReferralResponse[]> {
  const res = await apiCall<unknown>('/referrals', { accessToken });
  return ReferralResponseSchema.array().parse(res.data);
}
